<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8" style="padding-bottom:20px;">
                  <h4 class="mb-4">Reset Password</h4>
                  <p>Please enter your new password.</p>
                </div>
                <vs-input
                  type="email"
                  icon-no-border
                  icon="icon icon-mail"
                  icon-pack="feather"
                  label-placeholder="Email"
                  v-model="email"
                  class="w-full mb-6"
                  :disabled="!!this.$route.query.email"
                />
                <vs-input
                  type="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mb-6"
                />
                <vs-input
                  type="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Confirm Password"
                  v-model="password2"
                  class="w-full mb-8"
                />

                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                  <vs-button
                    type="border"
                    to="/login"
                    class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                  >Go Back To Login</vs-button>
                  <vs-button :disabled="!validateForm" class="w-full sm:w-auto" @click="reset">Reset</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: this.$route.query.email || '',
      password: '',
      password2: '',
      token: this.$route.query.token
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    reset () {
      if (this.password !== this.password2) {
        return this.$vs.notify({
          title: 'Password check incorrect',
          text: 'Please make sure the passwords are similar.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      this.$http.post('/auth/reset', { id: this.email, password: this.password, token: this.token })
        .then((result) => {
          console.log(result)
          if (result.data.error) {
            this.$vs.notify({
              title: 'Error',
              text: result.data.error,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
          this.$vs.notify({
            title: 'Password reset successful!',
            text: 'Please login with your new credentials.',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$router.push({ path: '/login' })
        })
        .catch(error => {
          console.log(error)
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>
